import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./Login";
import Links from "./Links";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/links" element={<Links />} />
        <Route path="*" element={<Login />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
